import StyledInput from "notes-and-forms-v2/components/styled-input/StyledInput";
import {
  ElementViewForClipboardProps,
  ElementViewProps,
} from "../AtomicElementView";
import styles from "./LinearScaleContent.module.scss";

function parseRawData(data) {
  if (!data) {
    return null;
  }

  if (typeof data === "number") {
    return data;
  }

  const parsed = parseInt(data, 10);
  if (isNaN(parsed)) {
    return null;
  }

  return parsed;
}

export function LinearScaleContentForClipboard({
  data: rawData,
}: ElementViewForClipboardProps<LinearScaleElement>) {
  const data = parseRawData(rawData);

  return <div>{data}</div>;
}
export default function LinearScaleContent({
  data: rawData,
  element,
  onChange,
  isDownloadMode,
  isLocked,
  disabled,
}: ElementViewProps<LinearScaleElement>) {
  const data = parseRawData(rawData);

  const options = new Array(element.rangeTo - element.rangeFrom + 1)
    .fill(0)
    .map((_, i) => i + element.rangeFrom);

  return (
    <div className={styles.container}>
      <div className={styles.rangeLabel}>{element.lowValueLabel}</div>
      <ul className={styles.optionList}>
        {options.map((option) => (
          <li className={styles.option} key={option}>
            <label
              htmlFor={`linear-scale-${element.id}-${option}`}
              onClick={() => {
                if (disabled || isLocked) {
                  return;
                }
                onChange(option);
              }}
            >
              <div className={styles["option__title"]}>{option}</div>
            </label>
            <StyledInput
              id={`linear-scale-${element.id}-${option}`}
              type="radio"
              checked={data === option}
              onChange={() => onChange(option)}
              disabled={disabled || isLocked}
              disableStyling={isDownloadMode}
            />
          </li>
        ))}
      </ul>
      <div className={styles.rangeLabel}>{element.highValueLabel}</div>
    </div>
  );
}
